import useDarkModeBase from 'use-dark-mode'

export function useDarkMode(addClassName = false) {
  return useDarkModeBase(undefined, {
    classNameDark: addClassName ? 'bp3-dark' : undefined,
    // @ts-ignore
    storageKey: null,
  })
}
